import { TweenLite } from "gsap";
import { observer } from "mobx-react";
import React, { Component } from "react";
import { MainStore } from "../../stores/MainStore";
import Label from "../Label";
import ContinentModalBody from "./ContinentModalBody";
import ContinentModalHeader from "./ContinentModalHeader";
import classes from "./styles.module.scss";
interface IProps {
  store: MainStore;
}
interface IState {}
@observer
class ContinentModal extends Component<IProps, IState> {
  animateRef: any;
  constructor(props: IProps) {
    super(props);
    this.animateRef = null;
  }
  componentDidMount() {
    if (this.animateRef !== null) {
      TweenLite.fromTo(
        this.animateRef,
        1,
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0 }
      );
    }
  }

  render() {
    const { store } = this.props;
    const { selectedContinent } = this.props.store;
    if (!selectedContinent) return null;
    return (
      <div
        ref={ref => (this.animateRef = ref)}
        className={classes.ContinentModal}
      >
        <ContinentModalHeader store={store} />
        <ContinentModalBody store={store} />
        <div
          onClick={e => {
            TweenLite.fromTo(
              this.animateRef,
              1,
              { opacity: 1, y: 0 },
              { opacity: 0, y: 50 }
            ).eventCallback("onComplete", () => store.closeContinent());
          }}
        >
          <Label
            uppercase
            bold
            extraSmall
            id={"generic.close"}
            className={classes.ContinentModalClose}
          />
        </div>
      </div>
    );
  }
}
export default ContinentModal;
